"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useWindowSize_1 = require("./useWindowSize");
function useBreakpoint(breakpoint) {
    var width = useWindowSize_1.useWindowSize().width;
    return width < breakpoint;
}
exports.useBreakpoint = useBreakpoint;
function useBreakpoints(breakpoints) {
    var width = useWindowSize_1.useWindowSize().width;
    return breakpoints.map(function (breakpoint) { return width < breakpoint; });
}
exports.useBreakpoints = useBreakpoints;
//# sourceMappingURL=useBreakpoint.js.map